import _classCallCheck from "/Users/matteo/Projects/GitHub/tsparticles/gatsby-landing-page-starter/node_modules/@babel/runtime/helpers/esm/classCallCheck";
export var Point = function Point(position, particle) {
  _classCallCheck(this, Point);

  this.position = position;
  this.particle = particle;
};